/**
 * Converts various date formats (Date object, timestamp, date string) to a Date object,
 * defaulting to current date if null is provided
 */

export const getDateFromValue = (value: Date | string | number | null): Date => {
  if (value instanceof Date) return value;
  if (value === null || !value) return new Date();
  if (Number.isNaN(Number(value))) return new Date(value); // Handle date string
  return new Date(Number(value)); // Handle timestamp
};
